export default __webpack_public_path__ + "static/media/stayHome.4240f10e.png";